type Props = { name: string };

function MobileUserChip({ name }: Props) {
  return <span className="mobile-task-user">
    <span className="mobile-task-user__avatar" aria-hidden="true">{name.slice(0, 1)}</span>
    <span className="mobile-task-user__name">{name}</span>
  </span>;
}

export default MobileUserChip;
